export function normalizeImportBarcode(value) {
  const barcode = String(value ?? "").trim();
  const internal = barcode.match(/^(?:ACC|AC)?(\d{1,7})$/i);
  return internal ? `ACC${internal[1].padStart(7, "0")}` : barcode;
}

export function getImportBarcodeError(value) {
  const barcode = normalizeImportBarcode(value);
  if (!barcode) return "Barkodi është i detyrueshëm.";
  if (!/^(?:\d{8}|\d{12}|\d{13}|\d{14})$/.test(barcode) && !/^ACC\d{7}$/i.test(barcode))
    return "Përdorni barkod standard me 8, 12, 13 ose 14 shifra, ose kod ACC me deri në 7 shifra.";
  return "";
}

export const isStandardImportBarcode = value => /^(?:\d{8}|\d{12}|\d{13}|\d{14})$/.test(String(value ?? "").trim());
export const needsGeneratedImportBarcode = row => !row.sourceIssues?.barcode && !isStandardImportBarcode(row.barcode);

// Preview allocation only; codes are not reserved in the database.
export function fillMissingImportBarcodes(rows, nextBarcode) {
  if (!rows.some(needsGeneratedImportBarcode)) return rows;
  const match = String(nextBarcode || "").match(/^ACC(\d{7})$/);
  if (!match || Number(match[1]) < 1) throw new Error("Seria e barkodave ACC nuk u verifikua. Provoni importimin përsëri.");
  let sequence = Number(match[1]);
  return rows.map(row => {
    if (!needsGeneratedImportBarcode(row)) return row;
    if (sequence > 9999999) throw new Error("Seria ACC nuk ka barkoda të mjaftueshëm për këtë import.");
    return { ...row, barcode: `ACC${String(sequence++).padStart(7, "0")}` };
  });
}
